import { Field, ImageField, LinkField, TextField } from '@sitecore-jss/sitecore-jss-nextjs';

import * as icons from '@gn-audio/icons';
import { ButtonVariantType, ComponentProps } from '@gn-audio/jss-components';

import { ThemeVariant } from 'common/types/themeConstants';

type ButtonSize = 's' | 'm' | 'l' | 'xs';

type FirstButtonSettings = {
  firstBtnLink: LinkField;
  firstBtnText: TextField;
  firstBtnAriaLabel?: Field<string>;
  firstBtnVariant: Field<ButtonVariantType>;
  firstBtnSize?: Field<ButtonSize>;
  firstBtnIcon?: Field<keyof typeof icons>;
};

type SecondButtonSettings = {
  secondBtnLink: LinkField;
  secondBtnText: TextField;
  secondBtnAriaLabel?: Field<string>;
  secondBtnVariant: Field<ButtonVariantType>;
  secondBtnSize?: Field<ButtonSize>;
  secondBtnIcon?: Field<keyof typeof icons>;
};

export type SliderProps = {
  header: Field<string>;
  cards: SliderCardProps[];
  spotThemeClass?: ThemeVariant;
  background?: Field<string>;
  centerWhenNotScrollable?: Field<boolean>;
  id?: string;
};
export type SliderSpotProps = {
  fields: SliderProps;
} & ComponentProps;

export type SliderCardProps = {
  id?: string;
  header: Field<string>;
  description: Field<string>;
  image: ImageField;
  background: Field<string>;
  icon: Field<keyof typeof icons>;
  iconBackground?: Field<string>;
  centerText: Field<boolean>;
} & FirstButtonSettings &
  SecondButtonSettings;
